import { combineReducers } from "redux";
import astrologerReducer from "./astrologerReducer";
import userReducer from "./userProfileReducer";
import cartReducer from "./cartReducer";
import wishlistReducer from "./wishlistReducer";
import masterDataReducer from "./masterdataReducer";
import settingReducer from "./settingReducer";
import homeReducer from "./homeReducer";
import globalSearchReducer from "./globalSearchReducer";

const rootreducer = combineReducers({
    astrologer: astrologerReducer,
    user_profile: userReducer,
    cartlist: cartReducer,
    wishlist: wishlistReducer,
    masterdata: masterDataReducer,
    settingdata: settingReducer,
    homedata: homeReducer,
    globalSearchData: globalSearchReducer,


});

export default rootreducer;